import { Outlet } from 'react-router-dom';

const PublicOutlet = () => {
  return <Outlet />;
};
export default PublicOutlet;
